export default class UsagiMouse {

	constructor( prop = {} ) {

		this.prop = prop;

		this.ease = this.prop.ease ? this.prop.ease : 0.1;
		this.array = [];

		this.x = window.innerWidth/2;
		this.y = window.innerHeight/2;
		this.currentEvent = null;

		this.currentTime = performance.now() * .001;
		this.lastTime = 0;
		this.deltaTime = 0;

		//
		if( typeof prop.onUpdateBefore === 'function' ) this.onUpdateBefore = () => prop.onUpdateBefore(this);
		if( typeof prop.onUpdateAfter === 'function' ) this.onUpdateAfter = () => prop.onUpdateAfter(this);


		//
		this.touch = {
			enable : false,
			start : {
				enable : false,
				x : 0
			},
			ing : {
				x : 0,
				delta : { x : 0 },
				ease : 0.025
			},
			end : {
				x : 0
			}
		}

		//
		if( this.ease.length ){
			this.isArray = true;
			this.onInitArray();
		} else {
			this.isArray = false;
			this.onInitSingle();
		}

	}

	onInitSingle(){
		this.center = { x : 0, y : 0 };
		this.three = { x : 0, y : 0 };
		this.shader = { x : 0, y : 0 };
		this.delta = { x : 0, y : 0 };
		this.speed = {
			prevEvent : null,
			x : 0,
			y : 0,
			xy : 0,
			delay : 50,
			delta : {
				ease : this.ease,
				x : 0,
				y : 0,
				xy : 0
			},
		}
		this.addEvents();
		this.onInitGetSpeed( this.speed );
		// this.onLoop();
	}

	onInitArray(){

		this.addEvents();

		for (let i = 0; i < this.ease.length; i++) {
			const v = this.ease[i];
			this.array.push({
				ease : v,
				center : { x : 0, y : 0 },
				three : { x : 0, y : 0 },
				shader : { x : 0, y : 0 },
				delta : { x : 0, y : 0 },
				speed : {
					prevEvent : null,
					x : 0,
					y : 0,
					xy : 0,
					delay : 50,
					delta : {
						ease : v,
						x : 0,
						y : 0,
						xy : 0
					},
				},
				lastTime : 0
			});
		}

		if( !DETECT.device.any ){
			this.array.forEach( (v,i) =>{
				this.onInitGetSpeed( v.speed );
			});
		}

		// this.onLoop();

	}

	onInitGetSpeed( s ){
		clearInterval( s.interval );
		s.interval = setInterval( () => {
			if( s.prevEvent && this.currentEvent){
				const x = this.currentEvent.screenX - s.prevEvent.screenX;
				const y = this.currentEvent.screenY - s.prevEvent.screenY;
				const ax = Math.abs( x );
				const ay = Math.abs( y );
				s.x  = x;
				s.y  = y;
				s.xy = 10 * Math.sqrt( ax * ax + ay * ay );
			}
			s.prevEvent = this.currentEvent;
		}, s.delay );
	}

	addEvents(){
		if( !DETECT.device.any ){
			this.onMouseMove = this.onMouseMove.bind(this);
			window.addEventListener('mousemove', this.onMouseMove );
		} else {
			this.onTouchStart = this.onTouchStart.bind(this);
			this.onTouchMove = this.onTouchMove.bind(this);
			this.onTouchEnd = this.onTouchEnd.bind(this);
			window.addEventListener('touchstart', this.onTouchStart );
			window.addEventListener('touchmove', this.onTouchMove );
			window.addEventListener('touchend', this.onTouchEnd );
		}
	}

	removeEvents(){
		if( !DETECT.device.any ){
			window.removeEventListener('mousemove', this.onMouseMove );
		} else {
			window.addEventListener('touchstart', this.onTouchStart );
			window.addEventListener('touchmove', this.onTouchMove );
			window.addEventListener('touchend', this.onTouchEnd );
		}
	}

	onTouchStart(e){
		let x = e.clientX;
		if( e.touches && e.touches[0] ){
			x = e.touches[0].clientX;
		}
		this.touch.enable = true;
		this.touch.start.enable = true;
		this.touch.start.x = x;
	}

	onTouchMove(e){
		let x = e.clientX;
		if( e.touches && e.touches[0] ){
			x = e.touches[0].clientX;
		} else if ( e.originalEvent && e.originalEvent.changedTouches[0] ) {
			x = e.originalEvent.changedTouches[0].clientX;
		}
		if( this.touch.start.enable ){
			const _x = this.touch.end.x + ( x - this.touch.start.x );
			this.touch.ing.x = clamp( _x / window.innerWidth, -1, 1 );
		}
	}

	onTouchEnd(e){
		this.touch.start.enable = false;
		this.touch.end.x = this.touch.ing.x;
		this.touch.ing.x = 0;
	}

	onMouseMove(e){
		this.x = e.clientX;
		this.y = e.clientY;
		this.currentEvent = e;
	}

	raf() {

		if( !DETECT.device.any ){
			this.onUpdateForDesktop();
		} else {
			this.onUpdateForMobile();			
		}

		// this.onRAF = requestAnimationFrame( this.onLoop.bind(this) );
	}

	lerp( from, to, ease ) {
		return to + ( from - to ) * ease;
	}

	onUpdateForDesktop(){
		if( this.onUpdateBefore ) this.onUpdateBefore( this );
		this.currentTime = performance.now() * .001;
		this.deltaTime = this.currentTime - this.lastTime;
		if( this.isArray ){
			for (let i = 0; i < this.array.length; i++) {
				this.onUpdateDelta( this.array[i] );
			}
		} else {
			this.onUpdateDelta( this );
		}
		this.lastTime = this.currentTime;
		if( this.onUpdateAfter ) this.onUpdateAfter( this );
	}

	onUpdateForMobile(){
		this.touch.ing.delta.x += ( this.touch.ing.x - this.touch.ing.delta.x ) * this.touch.ing.ease;
		this.touch.ing.delta.x = Math.abs( this.touch.ing.delta.x ) > 0.001 ? this.touch.ing.delta.x : 0;
	}

	onUpdateDelta( v ){
		const alpha = Math.exp( -v.ease * 85 * this.deltaTime );
		v.speed.delta.x  += ( v.speed.x - v.speed.delta.x ) * v.speed.delta.ease;
		v.speed.delta.y  += ( v.speed.y - v.speed.delta.y ) * v.speed.delta.ease;
		v.speed.delta.xy += ( v.speed.xy - v.speed.delta.xy ) * v.speed.delta.ease;
		v.delta.x = this.lerp( v.delta.x, this.x, alpha );
		v.delta.y = this.lerp( v.delta.y, this.y, alpha );	
		v.center.x = (v.delta.x - window.innerWidth/2) / window.innerWidth;
		v.center.y = (v.delta.y - window.innerHeight/2) / window.innerHeight;
		v.three.x  = v.center.x * window.innerWidth;
		v.three.y  = -v.center.y * window.innerHeight;
		v.shader.x = v.delta.x / window.innerWidth;
		v.shader.y = v.delta.y / window.innerHeight;
	}

	destory(){
		cancelAnimationFrame( this.onRAF );
		clearInterval( this.speed.interval );
		this.removeEvents();
	}
}